import { isNativo } from "~/utils/nativo.js";
import { tokenDaCookieDocumento } from "~/utils/tokenLocale.js";
import { deveTornareAlLogin, QUERY_SESSIONE_SCADUTA } from "~/utils/sessioneScaduta.js";

// Un 401 di un'API dall'area riservata vuol dire che la sessione non vale più: si torna al
// login, che rifà il controllo del dispositivo e mostra il motivo (es. «Accesso non
// disponibile…» per un'azienda archiviata). Sostituisce il $fetch globale una volta sola,
// perché le pagine lo chiamano ognuna per conto suo.
export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter();
  let inUscita = false;

  // Nell'app nativa la pagina sta su capacitor://localhost e l'API altrove: serve il baseURL e
  // il token va nell'header (il cookie del server non viaggia). Sul web non cambia nulla.
  // Il token si legge da document.cookie a ogni richiesta: il ref di useCookie può essere in
  // ritardo subito dopo salvaToken e la prima chiamata partirebbe senza header.
  const nativo = isNativo();
  const { apiBase, base_progetto } = useRuntimeConfig().public;
  const nomeCookie = `token${base_progetto}`;
  const eApi = (request) => {
    const url = typeof request === "string" ? request : request?.url;
    return typeof url === "string" && (url.startsWith("/api/") || (!!apiBase && url.startsWith(`${apiBase}/api/`)));
  };

  globalThis.$fetch = globalThis.$fetch.create({
    ...(nativo ? { baseURL: apiBase } : {}),
    onRequest({ request, options }) {
      if (!nativo || !eApi(request)) return;
      const token = tokenDaCookieDocumento(document.cookie, nomeCookie);
      if (!token) return;
      const headers = new Headers(options.headers || undefined);
      if (headers.has("Authorization")) return;
      headers.set("Authorization", `Bearer ${token}`);
      options.headers = headers;
    },
    onResponseError({ request, response }) {
      if (inUscita) return;
      const url = typeof request === "string" ? request : request?.url;
      if (!deveTornareAlLogin({ status: response?.status, url, percorsoPagina: router.currentRoute.value.path })) return;
      inUscita = true;
      Promise.resolve(
        nuxtApp.runWithContext(() => navigateTo({ path: "/", query: { sessione: QUERY_SESSIONE_SCADUTA } }, { replace: true })),
      ).finally(() => {
        inUscita = false;
      });
    },
  });
});
